import React from 'react';
import { Field } from './Form';

export interface FilterOption {
  value: string;
  label: string;
}

interface FilterDropdownProps {
  name: string;
  value: string[];
  onChange: (values: string[]) => void;
  options: FilterOption[];
  placeholder?: string;
  tooltip?: string;
  disableWhenEmpty?: boolean;
}

function FilterDropdown({
  name,
  value,
  onChange,
  options,
  placeholder,
  tooltip,
  disableWhenEmpty = false,
}: FilterDropdownProps) {
  return (
    <div title={tooltip}>
      <Field
        type="multiselect"
        title=""
        className="filter-dropdown"
        name={name}
        value={value}
        onChange={(e: Record<string, string[]>) => onChange(e[name])}
        selectData={options}
        placeholder={placeholder}
        disableWhenEmpty={disableWhenEmpty}
      />
    </div>
  );
}

export default FilterDropdown;
